import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchRegistrations } from '../services/api';
import { Registration } from '../types';
import DeviceLocationsMap from './DeviceLocationsMap';

const DeviceMapPage: React.FC = () => {
    const navigate = useNavigate();
    const [registrations, setRegistrations] = useState<Registration[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadRegistrations = async () => {
            try {
                const data = await fetchRegistrations();
                setRegistrations(data);
            } catch (err) {
                const message = err instanceof Error ? err.message : 'Failed to load map data';
                setError(message);
            } finally {
                setLoading(false);
            }
        };

        loadRegistrations();
    }, []);

    return (
        <div className="dashboard device-map-page">
            <div className="devices-header-row">
                <div>
                    <h2>Device map</h2>
                    <p className="summary">Spatial overview of all devices grouped by city.</p>
                </div>
                <button type="button" className="secondary-button" onClick={() => navigate('/devices')}>
                    Back to devices
                </button>
            </div>

            {loading && <div className="loading">Loading map...</div>}
            {!loading && error && <div className="error">{error}</div>}
            {!loading && !error && <DeviceLocationsMap registrations={registrations} layout="stacked" />}
        </div>
    );
};

export default DeviceMapPage;